import { Routes } from '@angular/router';
import { AppConfig } from './app.config';
import { HttpLoaderFactory } from './application/translation/httpLoaderFactory';
const appRoutes = [];
const ɵ0 = HttpLoaderFactory, ɵ1 = AppConfig;
export class AppModule {
}
export { ɵ0, ɵ1 };
